import { useParams } from 'react-router-dom'
import { useQuery } from '@apollo/client/react'
import Error from '@components/Error/Error'
import PageHeading from '@components/PageHeading/PageHeading'
import Table from '@components/pages/MiscellaneousDetail/DetailsTable'
import GET_MISCELLANEOUS_DETAIL from '@graphql/queries/get-miscellaneous-detail'

function Details() {
  const { miscellaneousDetailId } = useParams()
  const EXCLUDE_FROM_FIELDS = ['__typename', 'transactionId']
  const { data, loading, error } = useQuery(GET_MISCELLANEOUS_DETAIL, {
    variables: { id: miscellaneousDetailId }
  })

  const fields = data?.miscellaneousDetail ? Object.keys(data.miscellaneousDetail).filter((key) => !EXCLUDE_FROM_FIELDS.includes(key)) : []

  return (
    <>
      <PageHeading heading='Miscellaneous Detail Details' />

      {error ? (
        <Error error={error} />
      ) : (
        <Table
          miscellaneousDetail={data?.miscellaneousDetail}
          fields={fields}
          loading={loading}
        />
      )}
    </>
  )
}

export default Details
